<!--
 * @Author: 田鑫
 * @Date: 2022-01-10 10:34:27
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-25 15:23:22
 * @Description: 年夜饭预定订单管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="预订人电话：" prop="mobile">
          <el-input v-model="listParams.mobile" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="预定时间：" prop="datePicker">
          <el-date-picker placeholder="请输入" v-model="listParams.datePicker" type="date" value-format="timestamp"> </el-date-picker>
        </el-form-item>

        <el-form-item label="订单状态：" prop="orderStatus">
          <el-select v-model="listParams.orderStatus" placeholder="请选择">
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="待完成"></el-option>
            <el-option :value="2" label="已完成"></el-option>
            <el-option :value="3" label="已取消"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label-width="0px">
          <el-button type="primary" @click="loadTableData(true)">查询</el-button>
          <el-button @click="resetForm('listForm')">重置</el-button>
          <el-button type="danger" @click="exportExcel">导出订单</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" prop="orderNo" align="center"></el-table-column>
          <el-table-column label="预订人电话" prop="mobile" align="center"></el-table-column>
          <el-table-column label="预订餐厅" prop="canteenName" align="center"></el-table-column>
          <el-table-column label="预定房间" prop="roomName" align="center"></el-table-column>
          <el-table-column label="房间容量" prop="capacity" align="center"></el-table-column>
          <el-table-column label="预定时间" prop="" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.presetTime | formatDate }} {{ scope.row.type === 1 ? "午餐" : "晚餐" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" prop="orderStatus" align="center">
            <template slot-scope="scope">
              <span v-show="scope.row.orderStatus === 1">待完成</span>
              <span v-show="scope.row.orderStatus === 2">已完成</span>
              <span v-show="scope.row.orderStatus === 3">已取消</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="linkToDetailPage(scope.row.id)">详情</el-button>
              <confirm-button v-if="scope.row.orderStatus === 1" type="text" style="margin: 0 10px" title="确认要取消该订单吗？" @confirmed="cancelOrder(scope.row.id)">
                <span>取消订单</span>
              </confirm-button>
              <confirm-button v-if="scope.row.orderStatus === 1" type="text" style="margin: 0 10px" title="确认要完成该订单吗？" @confirmed="completeOrder(scope.row.id)">
                <span>完成订单</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";

export default {
  data() {
    return {
      listParams: {
        mobile: "",
        canteenName: "",
        orderStatus: 1,
        datePicker: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    };
  },

  mounted() {
    this.loadTableData();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = JSON.parse(JSON.stringify(Object.assign(this.listParams, this.pager)));
      if (bodyParams.datePicker) {
        bodyParams.presetStartTime = bodyParams.datePicker;
        bodyParams.presetEndTime = bodyParams.datePicker;
      } else {
        bodyParams.presetStartTime = "";
        bodyParams.presetEndTime = "";
      }
      delete bodyParams.datePicker;
      this.$http({
        url: global.apiUrl + "/family/order",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * @description: 重置表单
     * @param {*} name
     * @return {*}
     */
    resetForm(name) {
      this.$refs[name].resetFields();
      this.loadTableData();
    },
    /**
     * @description: 导出订单
     * @param {*}
     * @return {*}
     */
    exportExcel() {
      const bodyParams = JSON.parse(JSON.stringify(Object.assign(this.listParams, this.pager)));
      if (bodyParams.datePicker) {
        bodyParams.presetStartTime = bodyParams.datePicker;
        bodyParams.presetEndTime = bodyParams.datePicker;
      } else {
        bodyParams.presetStartTime = "";
        bodyParams.presetEndTime = "";
      }
      delete bodyParams.datePicker;
      bodyParams.accountToken = localStorage.getItem("TOKEN");

      download("/family/order/export", bodyParams, "年夜饭预定订单管理");
      // this.$router.open({
      //   path: "/api/web/family/order/export",
      //   query: bodyParams,
      //   type: "excel"
      // });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 详情
     * @param {*} id
     * @return {*}
     */
    linkToDetailPage(id) {
      this.$router.push({
        name: "reunionPreOrderDetail",
        query: {
          id,
        },
      });
    },
    /**
     * @description: 取消订单
     * @param {*} id
     * @return {*}
     */
    cancelOrder(id) {
      this.$http({
        url: global.apiUrl + "/order",
        method: "PUT",
        body: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 完成订单
     * @param {*} id
     * @return {*}
     */
    completeOrder(id) {
      this.$http({
        url: global.apiUrl + "/order/complete",
        method: "PUT",
        body: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
